import PropTypes from 'prop-types';
import classes from './section.module.css';

const Section = (props) => {
  const {
    children,
  } = props;

  return (children)
    ? <div className={classes.section} dangerouslySetInnerHTML={{ __html: children }} />
    : null;
};

Section.propTypes = {
  children: PropTypes.any,
};

export default Section;
